import PodcastEpisodesTable from './PodcastMetricsByEpisodeTable';

export default PodcastEpisodesTable;
